import * as React from 'react';
import { useSelector } from 'react-redux';
import { NewbuildingContactsContainerLoadable } from 'shared/components/contacts_aside';
import { NewbuildingOnlineStatusContainer } from 'shared/containers/NewbuildingOnlineStatusContainer';
import { isNewbuildingFromBuilderSelector } from 'shared/selectors';
import { selectIsBookedFromDeveloper } from 'shared/selectors/newbuildingBookedFromDeveloper';
import { selectIsChatsEnabled } from 'shared/selectors/offerChat';
import { isPrintVersionPhoneVisibilitySelector } from 'shared/selectors/print';

import { NewbuildingConsultantMessageButtonContainer } from '../NewbuildingConsultantMessageButtonContainer';
import { NewbuildingMessageButtonContainer } from '../NewbuildingMessageButtonContainer';
import { PhonesContainer } from '../PhonesContainer';
import { usePhonesOpenedContext } from '../providers/PhonesOpened';

export const NewbuildingPageAsideContactsContainer = () => {
  // флаг указывает включен ли чат с застройщиком
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const isNewbuildingFromDeveloper = useSelector(isNewbuildingFromBuilderSelector);

  const isPrintVersion = useSelector(isPrintVersionPhoneVisibilitySelector);

  const { isPhonesOpened } = usePhonesOpenedContext();

  const isBookedFromDeveloper = useSelector(selectIsBookedFromDeveloper);

  return (
    <>
      {!isPrintVersion && (
        <NewbuildingContactsContainerLoadable
          contactsButton={<PhonesContainer />}
          messageButton={
            isChatsEnabled ? (
              <NewbuildingMessageButtonContainer isPhonesOpened={isPhonesOpened} />
            ) : (
              <NewbuildingConsultantMessageButtonContainer isPhonesOpened={isPhonesOpened} />
            )
          }
          messageButtonInSeparateRow={isPhonesOpened}
        />
      )}
      {isNewbuildingFromDeveloper && !isBookedFromDeveloper && <NewbuildingOnlineStatusContainer />}
    </>
  );
};
